import React, { useState } from "react";
import SidebarDatas from "./SidebarDatas";
import { NavLink } from "react-router-dom";

function SideBarLayout({ setShowNav }) {
  const [toggleStyle, setToggleStyle] = useState(true);
  const sideLinkStyle = ({ isActive }) => {
    return `flex flex-row items-center py-3 w-full text-p-bk px-3 rounded-lg gap-2 ${
      isActive ? "bg-b-mc text-p-wh" : "normal"
    }`;
  };
  // const maxxl = 'max-xl:';
  const handleMouseOver = () => {
    setToggleStyle((toggleStyle) => !toggleStyle);
  };
  const handleMouseLeave = () => {
    setToggleStyle((toggleStyle) => toggleStyle);
  };

  return (
    <div className="w-full h-full flex flex-row">
      <div className=" flex flex-col w-full gap-8 text-sm max-lg:w-fi px-4 py-2 bg-p-wh shadow-lg">
        <div className="flex flex-col gap-2 w-ful ">
          {SidebarDatas.sideBarArrprimary.map((link) => {
            return (
              <NavLink
                key={link.id}
                to={link.path}
                className={sideLinkStyle}
                onMouseEnter={handleMouseOver}
                onMouseLeave={handleMouseLeave}
                onClick={() => setShowNav(false)}
              >
                <span className="text-xl">{link.icon}</span>
                <span
                  className={toggleStyle ? "pe- max-lg:hidde" : "max-lg:bloc"}
                >
                  {link.name}
                </span>
              </NavLink>
            );
          })}
        </div>
        <hr></hr>
        <div className="flex flex-col gap-2 w-full">
          {SidebarDatas.sideBarArrsecondary.map((link) => {
            return (
              <NavLink
                key={link.id}
                to={link.path}
                className={sideLinkStyle}
                onMouseEnter={handleMouseOver}
                onMouseLeave={handleMouseLeave}
                onClick={() => setShowNav(false)}
              >
                <span className="text-xl">{link.icon}</span>
                <span
                  className={toggleStyle ? "pe- max-lg:hidde" : "max-lg:bloc"}
                >
                  {link.name}
                </span>
              </NavLink>
            );
          })}
        </div>
      </div>
      {/* <div className=" ">
        <Outlet />
      </div> */}
    </div>
  );
}
export default SideBarLayout;
